import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"mt-10",attrs:{"fluid":"","pa-5":""}},[_c(VRow,{attrs:{"justify":"center"}},[_c(VCol,{attrs:{"cols":"12","xs":"12","sm":"8","md":"6","lg":"4"}},[_c(VCard,{staticClass:"elevation-12 pa-2",staticStyle:{"border-radius":"12px"}},[_c('div',{staticClass:"d-flex justify-center"},[_c(VImg,{staticClass:"ma-3",attrs:{"contain":"","src":_vm.logo,"max-width":"300"}})],1),_c(VCardText,[_vm._t("form")],2),_c(VCol,{attrs:{"cols":"12"}},[_vm._t("control")],2)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }